import { registerHandler } from "@utils/pixels/handler";

declare const window: Window & {
  AddShoppersConversion?: any;
  AddShoppersWidget?: any;
};

export default function registerHandlers() {
  registerHandler("lead", async ({ userId }) => {
    window.AddShoppersConversion = {
      order_id: `${userId}`,
      value: 10,
    };

    if (window.AddShoppersWidget) {
      window.AddShoppersWidget.track_conv();
    }
  });
}
